(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'BestPriceAnalytics';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("bestprice", TrackingModel);

        if (!Tracker || !Tracker.Properties.BestPriceAnalyticsId)
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack();

        Init();

        function Init() {
            if (!CanTrack) return;

            (function (a, b, c, d, s) {
                a.__bp360 = c; a[c] = a[c] || function () { (a[c].q = a[c].q || []).push(arguments); };
                s = b.createElement('script'); s.async = true; s.src = d; s.charset = 'utf-8'; (b.body || b.head).appendChild(s);
            })(window, document, 'bp', '//360.bestprice.gr/360.js');

            bp('connect', Tracker.Properties.BestPriceAnalyticsId);

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                var tracked = false;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                        if (oScope && !tracked) {
                            if (TrackingModel.IsThankYouPage) //cookie consent had been granted
                            {
                                tracked = true;

                                var items = TrackingModel.CartProductsData;

                                var adjustedPriceItems = items.map(function (i) {
                                    return { Quantity: i.Quantity, PriceN: i.PriceN }
                                });

                                var orderDiscountsNotAppliedOnProductsN = TrackingData.Order.Discounts.Order.reduce(
                                    function (total, discount) {
                                        return total + (discount.IsSpitOnProducts ? 0 : discount.AmountN);
                                    }, 0);

                                if (orderDiscountsNotAppliedOnProductsN > 0)
                                    adjustedPriceItems = AdjustPrices(adjustedPriceItems, orderDiscountsNotAppliedOnProductsN);

                                var bpOrder = {
                                    orderId: TrackingModel.Order.Id,
                                    revenue: Math.max(0, TrackingModel.Order.TotalPriceN - TrackingModel.Order.PaymentCostN),
                                    shipping: TrackingModel.Order.ShippingCostN,
                                    tax: TrackingModel.Order.VatCostN
                                }
                                bp('addOrder', bpOrder);

                                if (console)
                                    console.log({ 'BestPriceAnalytics_addOrder': bpOrder });

                                for (var i = 0, len = items.length; i < len; i++) {
                                    var product = items[i];
                                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                    var bpProduct = {
                                        orderId: TrackingModel.Order.Id,
                                        productId: productId,
                                        title: product.Name,
                                        price: adjustedPriceItems[i].PriceN,
                                        quantity: product.Quantity
                                    }
                                    bp('addProduct', bpProduct);

                                    if (console)
                                        console.log({ 'BestPriceAnalytics_addItem': bpProduct });
                                };
                            }
                        }
                    });
                }
            }
        }

        function AdjustPrices(orderItems, priceReduction) {

            var orderItemsSumN = orderItems.reduce(
                function (total, item) {
                    return total + (item.PriceN * item.Quantity);
                },
                0);

            if (orderItemsSumN <= 0)
                return orderItems;

            var totalDistributedDiscount = 0;
            for (var k = orderItems.length - 1; k >= 0; k--) {
                var productVolumePercent = (orderItems[k].PriceN * orderItems[k].Quantity) / orderItemsSumN;

                var productDiscount;

                if (k == 0)
                    productDiscount = priceReduction - totalDistributedDiscount;
                else
                    productDiscount = productVolumePercent * priceReduction;

                totalDistributedDiscount = Math.round(totalDistributedDiscount + productDiscount, 2);

                var productUnitdiscount = Math.round(productDiscount / orderItems[k].Quantity, 2);
                orderItems[k].PriceN = Math.round(Math.max(0, orderItems[k].PriceN - productUnitdiscount), 2);
            }

            return orderItems;
        }
    });
})();
